export * from './mb-wishlist.connector'
